// @team BFA Acquisition
import { isBrowser } from '@bfa/nextjs-common/utils';
import flow from 'lodash/flow';
import { NextPageContext, NextPageWithInitialProps } from 'next';

import Quiz from '../../../../features/Quiz/pages/Quiz';
import { initApolloClient } from '../../../../utils/apollo';
import { withApolloContext } from '../../../../utils/apollo';
import { Coupon, getCouponConfig } from '../../../../utils/getCouponConfig';
import isBoxycharmSubdomain from '../../../../utils/isBoxycharmSubdomain';

type QuizPageProps = {
  isBoxycharmSubdomain?: boolean;
  baseUrl?: string;
  coupon?: Coupon;
};

const QuizWrapper: NextPageWithInitialProps<QuizPageProps> = ({
  baseUrl,
  isBoxycharmSubdomain,
  coupon,
}) => (
  <Quiz
    baseUrl={baseUrl}
    isBoxycharmSubdomain={isBoxycharmSubdomain}
    coupon={coupon}
  />
);

export const getQuizPageInitialProps = async (
  ctx: NextPageContext
): Promise<QuizPageProps> => {
  const client = initApolloClient({}, ctx);
  const coupon = await getCouponConfig(client, ctx);

  return {
    baseUrl: isBrowser ? window?.location?.host : ctx?.req?.headers?.host,
    isBoxycharmSubdomain: isBoxycharmSubdomain(ctx),
    coupon: coupon,
  };
};

QuizWrapper.getInitialProps = getQuizPageInitialProps;

const Cmp = flow(withApolloContext({ ssr: true }))(QuizWrapper);

Cmp.displayName = 'Quiz/Take/Questions';

export default Cmp;
